import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Components
import { AnimationComponent } from './animation.component';

const sharedComponents = [AnimationComponent];

@NgModule({
  exports: [...sharedComponents],
  imports: [
    CommonModule,
    ...sharedComponents,
  ],
})
export class AnimationsModule { }
